import BelowcontentPage from "./belowcontent";
import ArjunPage from "./arjunpage";

const RobocopMainPage = () => {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        overflowX: "hidden",
        background: `
          radial-gradient(circle at 70% 35%, rgba(75,192,217,0.35), transparent 40%),
          radial-gradient(circle at 25% 70%, rgba(26,58,110,0.35), transparent 50%),
          linear-gradient(to bottom, #07192e, #0a2540, #103f65, #4bc0d9)
        `
      }}
    >
      <BelowcontentPage />
      <ArjunPage />
    </div>
  );
};

export default RobocopMainPage;
